import { render, staticRenderFns } from "./ReleaseOrder.vue?vue&type=template&id=6d8c994a&scoped=true"
import script from "./ReleaseOrder.vue?vue&type=script&lang=js"
export * from "./ReleaseOrder.vue?vue&type=script&lang=js"
import style0 from "./ReleaseOrder.vue?vue&type=style&index=0&id=6d8c994a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c994a",
  null
  
)

export default component.exports